<template>
  <div>
    <!--面包屑导航-->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>首页</el-breadcrumb-item>
      <el-breadcrumb-item>常用数据</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <el-row :gutter="20">
        <el-col :span="4">
          <el-button type="primary" icon="el-icon-refresh" @click="refreshData">刷新数据</el-button>
        </el-col>
      </el-row>
      <!-- 3个数据展示板块（栅格布局，适配不同屏幕） -->
      <el-row :gutter="20" class="data-card-container">
        <!-- 板块1：整体统计 -->
        <el-col :xs="24" :sm="12" :md="8" class="data-col">
          <div class="data-card">
            <div class="card-header">
              <i class="el-icon-s-data card-icon"></i>
              <span class="card-title">整体数据</span>
            </div>
            <div class="card-body">
              <div class="data-item">
                <span class="label">总库存：</span>
                <span class="value">{{ (totalData.totalDataCur / 1000).toFixed(2) }} 吨</span>
              </div>
              <!-- <div class="data-divider"></div>
              <div class="data-item">
                <span class="label">进货总量：</span>
                <span class="value">{{ totalData.totalDataInNum }} 公斤</span>
              </div>
              <div class="data-item">
                <span class="label">进货总价：</span>
                <span class="value">¥ {{ totalData.totalDataInMoney }}</span>
              </div>
              <div class="data-item">
                <span class="label">平均进货价：</span>
                <span class="value">¥ {{ totalData.totalDataInPrice }}</span>
              </div>
              <div class="data-divider"></div>
              <div class="data-item">
                <span class="label">销售总量：</span>
                <span class="value">{{ totalData.totalDataOutNum }} 公斤</span>
              </div>
              <div class="data-item">
                <span class="label">销售总价：</span>
                <span class="value">¥ {{ totalData.totalDataOutMoney }}</span>
              </div>
              <div class="data-item">
                <span class="label">平均销售价：</span>
                <span class="value">¥ {{ totalData.totalDataOutPrice }}</span>
              </div> -->
            </div>
          </div>
        </el-col>
        <!-- 板块2：紫铜数据 -->
        <el-col :xs="24" :sm="12" :md="8" class="data-col">
          <div class="data-card">
            <div class="card-header">
              <i class="el-icon-money card-icon"></i>
              <span class="card-title">紫铜数据</span>
            </div>
            <div class="card-body">
              <div class="data-item">
                <span class="label">紫铜库存：</span>
                <span class="value">{{ (ziData.ziDataCur/1000).toFixed(2) }} 吨</span>
              </div>
              <!-- <div class="data-divider"></div> -->
              <!-- <div class="data-item">
                <span class="label">进货总量：</span>
                <span class="value">{{ ziData.ziDataInNum }} 公斤</span>
              </div>
              <div class="data-item">
                <span class="label">进货总价：</span>
                <span class="value">¥ {{ ziData.ziDataInPrice }}</span>
              </div>
              <div class="data-item">
                <span class="label">平均进货价：</span>
                <span class="value">¥ {{ ziData.ziDataInPrice }}</span>
              </div>
              <div class="data-divider"></div>
              <div class="data-item">
                <span class="label">销售总量：</span>
                <span class="value">{{ ziData.ziDataOutNum }} 公斤</span>
              </div>
              <div class="data-item">
                <span class="label">销售总价：</span>
                <span class="value">¥ {{ ziData.ziDataOutMoney }}</span>
              </div>
              <div class="data-item">
                <span class="label">平均销售价：</span>
                <span class="value">¥ {{ ziData.ziDataOutPrice }}</span>
              </div> -->
            </div>
          </div>
        </el-col>

        <!-- 板块3：黄铜数据 -->
        <el-col :xs="24" :sm="12" :md="8" class="data-col">
          <div class="data-card">
            <div class="card-header">
              <i class="el-icon-warning card-icon"></i>
              <span class="card-title">黄铜数据</span>
            </div>
            <div class="card-body">
              <div class="data-item">
                <span class="label">黄铜库存：</span>
                <span class="value">{{(huangData.huangDataCur/1000).toFixed(2)}} 吨</span>
              </div>
              <!-- <div class="data-divider"></div>
              <div class="data-item">
                <span class="label">进货总量：</span>
                <span class="value">{{ huangData.huangDataInNum }} 公斤</span>
              </div>
              <div class="data-item">
                <span class="label">进货总价：</span>
                <span class="value">¥ {{ huangData.huangDataInMoney }}</span>
              </div>
              <div class="data-item">
                <span class="label">平均进货价：</span>
                <span class="value">¥ {{ huangData.huangDataInPrice }}</span>
              </div>
              <div class="data-divider"></div>
              <div class="data-item">
                <span class="label">销售总量：</span>
                <span class="value">{{ huangData.huangDataOutNum }} 公斤</span>
              </div>
              <div class="data-item">
                <span class="label">销售总价：</span>
                <span class="value">¥ {{ huangData.huangDataOutMoney }}</span>
              </div>
              <div class="data-item">
                <span class="label">平均销售价：</span>
                <span class="value">¥ {{ huangData.huangDataOutPrice }}</span>
              </div> -->
            </div>
          </div>
        </el-col>
                <!-- 板块3：黄铜数据 -->
        <el-col :xs="24" :sm="12" :md="8" class="data-col">
          <div class="data-card">
            <div class="card-header">
              <i class="el-icon-warning card-icon"></i>
              <span class="card-title">铜包铜数据</span>
            </div>
            <div class="card-body">
              <div class="data-item">
                <span class="label">铜包铜库存：</span>
                <span class="value">{{(baoData.baoDataCur/1000).toFixed(2)}} 吨</span>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
  </div>
</template>

<script>
const PUBTOOLS = require('../utils/pubtools');
import $httpREQUEST from '@/utils/request';
export default {
  name: "firstpage",
  data() {
    return {
      //整体数据
      totalData: {
        totalDataCur: 0,// 当前库存
        totalDataInNum: 0,//
        totalDataInMoney: 0,//
        totalDataInPrice: 0,//
        totalDataOutNum: 0,//
        totalDataOutMoney: 0,//
        totalDataOutPrice: 0//
      },
      ziData: {
        ziDataCur: 0,// 当前库存
        ziDataInNum: 0,//
        ziDataInMoney: 0,//
        ziDataInPrice: 0,//
        ziDataOutNum: 0,//
        ziDataOutMoney: 0,//
        ziDataOutPrice: 0//
      },
      huangData: {
        huangDataCur: 0,// 当前库存
        huangDataInNum: 0,//
        huangDataInMoney: 0,//
        huangDataInPrice: 0,//
        huangDataOutNum: 0,//
        huangDataOutMoney: 0,//
        huangDataOutPrice: 0//
      },
      baoData: {
        baoDataCur: 0,// 当前库存
        baoDataInNum: 0,//
        baoDataInMoney: 0,//
        baoDataInPrice: 0,//
        baoDataOutNum: 0,//
        baoDataOutMoney: 0,//
        baoDataOutPrice: 0//
      }
    };
  },
  mounted() {
    // 页面加载时获取数据
    this.getData();
  },
  methods: {
        /**
     * 限制数值为2位小数（处理空值、非数字、四舍五入）
     * @param {number|string} num - 要格式化的数值（支持数字/字符串）
     * @returns {number} 格式化后的2位小数数值
     */
    formatTo2Decimal(num){
      // 1. 转为数字（空值/非数字转为0）
      const number = Number(num);
      
      if (isNaN(number)){
         return 0.00;
      }
      // 2. 保留2位小数（四舍五入），并转回数字（toFixed返回字符串）
      return Number(number.toFixed(2));
    },
    // 模拟从后端获取数据（实际项目中替换为真实接口）
    async getData() {
      const {data: res} = await $httpREQUEST.get('/api/showData/getdata', {params: PUBTOOLS.addParams()})
      if (res.status !== 0) return this.$message.error('获取数据失败');
      console.log(res);
      if (res.data) {
        //处理total
        this.totalData.totalDataCur = this.formatTo2Decimal(res.data.ingoods.totalDataInNum - res.data.outgoods.totalDataOutNum);
        this.totalData.totalDataInNum = res.data.ingoods.totalDataInNum;
        this.totalData.totalDataInMoney = res.data.ingoods.totalDataInMoney;
        this.totalData.totalDataInPrice = this.formatTo2Decimal(res.data.ingoods.totalDataInMoney/res.data.ingoods.totalDataInNum);
        this.totalData.totalDataOutNum = res.data.outgoods.totalDataOutNum;
        this.totalData.totalDataOutMoney = res.data.outgoods.totalDataOutMoney;
        this.totalData.totalDataOutPrice = this.formatTo2Decimal(res.data.outgoods.totalDataOutMoney/res.data.outgoods.totalDataOutNum);

        //处理紫铜
        this.ziData.ziDataCur = this.formatTo2Decimal(res.data.ingoods.ziDataInNum - res.data.outgoods.ziDataOutNum);
        this.ziData.ziDataInNum = res.data.ingoods.ziDataInNum;
        this.ziData.ziDataInMoney = res.data.ingoods.ziDataInMoney;
        this.ziData.ziDataInPrice = this.formatTo2Decimal(res.data.ingoods.ziDataInMoney/res.data.ingoods.ziDataInNum);
        this.ziData.ziDataOutNum = res.data.outgoods.ziDataOutNum;
        this.ziData.ziDataOutMoney = res.data.outgoods.ziDataOutMoney;
        this.ziData.ziDataOutPrice = this.formatTo2Decimal(res.data.outgoods.ziDataOutMoney/res.data.outgoods.ziDataOutNum);
        
        // 处理黄铜
        this.huangData.huangDataCur = this.formatTo2Decimal(res.data.ingoods.huangDataInNum - res.data.outgoods.huangDataOutNum);
        this.huangData.huangDataInNum = res.data.ingoods.huangDataInNum;
        this.huangData.huangDataInMoney = res.data.ingoods.huangDataInMoney;
        this.huangData.huangDataInPrice = this.formatTo2Decimal(res.data.ingoods.huangDataInMoney/res.data.ingoods.huangDataInNum);
        this.huangData.huangDataOutNum = res.data.outgoods.huangDataOutNum;
        this.huangData.huangDataOutMoney = res.data.outgoods.huangDataOutMoney;
        this.huangData.huangDataOutPrice = this.formatTo2Decimal(res.data.outgoods.huangDataOutMoney/res.data.outgoods.huangDataOutNum);

        // 处理铜包铜
        this.baoData.baoDataCur = this.formatTo2Decimal(res.data.ingoods.baoDataInNum - res.data.outgoods.baoDataOutNum);
        this.baoData.baoDataInNum = res.data.ingoods.baoDataInNum;
        this.baoData.baoDataInMoney = res.data.ingoods.baoDataInMoney;
        this.baoData.baoDataInPrice = this.formatTo2Decimal(res.data.ingoods.baoDataInMoney/res.data.ingoods.baoDataInNum);
        this.baoData.baoDataOutNum = res.data.outgoods.baoDataOutNum || 0;
        this.baoData.baoDataOutMoney = res.data.outgoods.baoDataOutMoney;
        this.baoData.baoDataOutPrice = this.formatTo2Decimal(res.data.outgoods.baoDataOutMoney/res.data.outgoods.baoDataOutNum);
      }
      this.$message.success("数据加载成功");
    },
    // 刷新数据
    refreshData() {
      this.$message.info("正在刷新数据...");

      this.getData();
    },
  },
};
</script>

<style scoped>
/* 页面整体样式 */
.data-display-page {
  padding: 20px;
  background-color: #f5f7fa;
  min-height: calc(100vh - 60px);
}
.data-divider {
  height: 1px;
  background-color: transparent;
  border-top: 1px dashed #dcdcdc;
  margin: 8px 0;
}

/* 页面标题栏 */
.page-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.page-header h2 {
  margin: 0;
  color: #1f2d3d;
  font-weight: 600;
}

/* 卡片容器 */
.data-card-container {
  margin-bottom: 20px;
}

.data-col {
  margin-bottom: 20px;
}

/* 数据卡片样式 */
.data-card {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.05);
  padding: 20px;
  height: 100%;
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.card-icon {
  font-size: 20px;
  color: #409eff;
  margin-right: 8px;
}

.card-title {
  font-size: 16px;
  font-weight: 600;
  color: #303133;
}

/* 卡片内容 */
.card-body {
  padding-top: 10px;
}

.data-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
}

.data-item:last-child {
  margin-bottom: 0;
}

.label {
  color: #606266;
}

.value {
  color: #1f2d3d;
  font-weight: 600;
}
</style>